import { useState } from 'react';
import { hapticTap } from '../../lib/native.js';
import { openInboxSettings, setInboxWanted } from '../../lib/inbox.js';
import { GlyphBell, GlyphLock } from '../ui/Glyphs.js';
import './inbox-consent.css';

/**
 * Aviso em destaque exigido pelo Google Play antes de pedir o acesso a notificações:
 * o que o app lê, para quê e onde fica, em três linhas, com "Permitir" e "Agora não".
 * Fechar ou voltar não vale como permissão.
 */
export function InboxConsent({ onClose }: { onClose: () => void }) {
  const [going, setGoing] = useState(false);
  async function allow() {
    hapticTap();
    setGoing(true);
    setInboxWanted(true);
    await openInboxSettings();
    onClose();
  }
  return (
    <div className="ibc-wrap" role="dialog" aria-modal="true" aria-labelledby="ibc-title">
      <div className="ibc">
        <span className="ibc-kicker">Mensagens de outros apps</span>
        <h2 id="ibc-title">Posso ler as notificações do WhatsApp, Telegram e SMS?</h2>
        <p className="ibc-lead">
          Com o app aberto, eu mostro quem escreveu e você responde por aqui, sem trocar de app.
        </p>
        <ul className="ibc-points">
          <li>
            <i>
              <GlyphBell />
            </i>
            <span>
              <b>O que eu leio</b>
              <small>Quem escreveu e o texto, só de apps de mensagem.</small>
            </span>
          </li>
          <li>
            <i>
              <GlyphLock />
            </i>
            <span>
              <b>Onde fica</b>
              <small>Só no seu aparelho. Não guardo, não envio, não treina nada.</small>
            </span>
          </li>
        </ul>
        <p className="ibc-how">
          Na tela do Android que abre em seguida, ligue a chave do Secretário. Desliga quando
          quiser, lá ou em Conta › Notificações.
        </p>
        <div className="ibc-acts">
          <button
            type="button"
            className="ibc-btn solid"
            disabled={going}
            onClick={() => void allow()}
          >
            Permitir
          </button>
          <button type="button" className="ibc-btn" onClick={onClose}>
            Agora não
          </button>
        </div>
      </div>
    </div>
  );
}
